import { WILL_CALL_LIST_ENDPOINT } from '../../apiEndpoints/index.endpoint';
import { APIRequest } from '../../helpers/index.helper';
import { logger } from '../../utils';

export const getWillCallListService = async ({ queryParams, type }) => {
  try {
    const payload = {
      ...WILL_CALL_LIST_ENDPOINT?.getWillCallList,
      queryParams,
    };
    const res = await APIRequest(payload);
    if (res?.data?.rows && type === 'all') {
      return res?.data?.rows;
    }
    return res;
  } catch (err) {
    logger(err);
  }
};

export const updateWillCallListStatus = async ({ bodyData, queryParams }) => { 
  try {
    const payload = {
      ...WILL_CALL_LIST_ENDPOINT.willCallListStatusUpdate(queryParams),
      bodyData,
    };

    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    console.log(err);
    logger(err);
  }
};
